// extracted by mini-css-extract-plugin
export default {"avatar":"ntf7pI","withBorder":"zZnfWr","memberInitials":"mmo22C","avatarPlaceholder":"y3wb9G","withLoggedOutHeight":"k8QWVn"};